// extracted by mini-css-extract-plugin
export default {"body":"oLca1","reminder":"JaVM1","personalList":"sCkXL","personalItem":"yOlsG"};